/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_Duplicated_HintInputs */

const vi_einvoice_publish_duplicated_hint = /** @type {(inputs: Einvoice_Publish_Duplicated_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra trên meInvoice theo khách hàng, số tiền và ngày. Có hóa đơn thì báo quản trị số hóa đơn; không có thì báo quản trị để mở phát hành lại. Không tự phát hành lại.`)
};

/**

* @param {Einvoice_Publish_Duplicated_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_duplicated_hint = /** @type {((inputs?: Einvoice_Publish_Duplicated_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_Duplicated_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_duplicated_hint(inputs)
});